export const TABLE_CONFIG = {
  /** Average row height in pixels */
  DEFAULT_ROW_HEIGHT: 53,
  /** Number of off-screen rows to pre-render */
  DEFAULT_OVERSCAN: 10,
  /** Default page size */
  DEFAULT_PAGE_SIZE: 25,
  /** Toast display duration in ms */
  DEFAULT_TOAST_DURATION: 4000,
  /** Error toast position */
  TOAST_ERROR_POSITION: "bottom-right" as const,
} as const;

/** User-facing error messages (French) */
export const ERROR_MESSAGES = {
  PERMISSION_DENIED: "Vous n'avez pas la permission d'accéder à cette ressource.",
  NETWORK_ERROR: "Erreur de connexion. Vérifiez votre connexion internet.",
  SERVER_ERROR: "Erreur serveur. Veuillez réessayer ultérieurement.",
  GENERIC_ERROR: "Une erreur s'est produite lors du chargement des données.",
  MERCURE_ERROR: "Erreur lors des mises à jour en temps réel.",
} as const;
